export const TableHeader = [
  {
    name: "ユーザー名",
    subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
    sizeInner: "100px",
    minSizeContainer: "180px"
  },
  {
    name: "大学名",
    subHeaders: [{ name: "卒年" }, { name: "学部・学年" }],
    sizeInner: "100px",
    minSizeContainer: "220px"
  },
  {
    name: "申込イベント",
    sizeInner: "100px",
    minSizeContainer: "140px"
  },
  {
    name: "申込スケジュール",
    subHeaders: [{ name: "スケジュール開催日" }],
    minSizeContainer: "250px"
  },
  {
    name: "申込日時",
    sizeInner: "130px",
    minSizeContainer: "170px",
    sortParam: "entried_at",
    order: "desc"
  }
];
